package br.com.texeratx.boardgametimeapp.ui.screens.games.detail

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppScreenScaffold
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppSnackbarTone
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEventBus
import br.com.texeratx.boardgametimeapp.ui.screens.expansions.create.CreateExpansionScreen
import br.com.texeratx.boardgametimeapp.ui.screens.matches.detail.MatchDetailScreen
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class GameDetailScreen(
    private val gameId: Long
) : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinInject<GameDetailViewModel>()

        val game by viewModel.game.collectAsState()
        val isLoading by viewModel.isLoading.collectAsState()
        val isSaving by viewModel.isSaving.collectAsState()
        val error by viewModel.error.collectAsState()
        val uiMessage by viewModel.uiMessage.collectAsState()

        val snackbarHostState = remember { SnackbarHostState() }
        val navigator = cafe.adriel.voyager.navigator.LocalNavigator.currentOrThrow
        var showDeleteConfirmation by remember { mutableStateOf(false) }

        LaunchedEffect(gameId) {
            viewModel.loadGame(gameId)
        }

        LaunchedEffect(navigator.lastItem) {
            if (navigator.lastItem is GameDetailScreen) {
                viewModel.loadGame(gameId)
            }
        }

        LaunchedEffect(uiMessage) {
            uiMessage?.let {
                snackbarHostState.showSnackbar(it)
                viewModel.uiMessage.value = null
            }
        }

        when {
            isLoading -> {
                Box(
                    Modifier.fillMaxSize(),
                    contentAlignment = Alignment.Center
                ) {
                    CircularProgressIndicator()
                }
            }

            error != null -> {
                Text("Erro: $error")
            }

            game != null -> {
                val gameNonNull = game!!

                AppScreenScaffold(
                    snackbarHost = { SnackbarHost(snackbarHostState) }
                ) { innerPadding ->
                    GameDetailUI(
                        game = gameNonNull,
                        modifier = Modifier.fillMaxSize(),
                        contentPadding = innerPadding,
                        onEditClick = {
                            navigator.push(
                                br.com.texeratx.boardgametimeapp.ui.screens.games.edit.EditGameScreen(gameId)
                            )
                        },
                        onDeleteClick = { showDeleteConfirmation = true },
                        showDeleteConfirmation = showDeleteConfirmation,
                        isDeleting = isSaving,
                        onDismissDeleteConfirmation = { showDeleteConfirmation = false },
                        onConfirmDelete = {
                            showDeleteConfirmation = false
                            viewModel.deleteGame(gameId) {
                                navigator.pop()
                                AppUiEventBus.publishMessage(
                                    message = "Jogo exclu�do com sucesso.",
                                    tone = AppSnackbarTone.Success
                                )
                            }
                        },
                        onCreateExpansionClick = {
                            navigator.push(CreateExpansionScreen(prefilledGameId = gameId))
                        },
                        onMatchClick = { match ->
                            navigator.push(MatchDetailScreen(match))
                        }
                    )
                }
            }
        }
    }
}
